import { Dispatch } from 'redux'
import { ActionType, DeliveriesAction } from './actionTypes'
import { Delivery, DeliveryOrder } from './types'

export const updateDeliveryOrders = (deliveryOrders: DeliveryOrder[]) => {
    return (dispatch: Dispatch<DeliveriesAction>) => {
        dispatch({
            type: ActionType.UPDATE_DELIVERY_ORDERS,
            payload: deliveryOrders
        })
    }
}

export const removeDeliveryOrders = (ids: string[]) => {
    return (dispatch: Dispatch<DeliveriesAction>) => {
        dispatch({
            type: ActionType.REMOVE_DELIVERY_ORDERS,
            payload: ids
        })
    }
}

export const updateDeliveries = (deliveries: Delivery[]) => {
    return (dispatch: Dispatch<DeliveriesAction>) => {
        dispatch({
            type: ActionType.UPDATE_DELIVERIES,
            payload: deliveries
        })
    }
}

export const removeDeliveries = (ids: string[]) => {
    return (dispatch: Dispatch<DeliveriesAction>) => {
        dispatch({
            type: ActionType.REMOVE_DELIVERIES,
            payload: ids
        })
    }
}
